import { Component, OnInit, HostBinding, 
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { TerritoriesData, TerritoriesService }  from './Territories.service';

import { RegionData, RegionService } from '../Region/Region.service';

@Component({
  template: require('./TerritoriesDetails.component.html'),
  providers: [TerritoriesService
	, RegionService
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class TerritoriesDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
  
	objTerritories: TerritoriesData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	RegionList: RegionData[];

	constructor(private route: ActivatedRoute, 
		private router: Router, 
		private toastr: ToastsManager,
		private TerritoriesService: TerritoriesService
			, private  RegionService:  RegionService

	) {
		// this.id = parseInt(params.get('id'));
		this.objTerritories = new TerritoriesData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.TerritoriesService.getByID(+params['id']))
		.switchMap((params: Params) => this.TerritoriesService.getByID(params['id']))
		.subscribe((item: TerritoriesData) => this.objTerritories = item);
		this.getLookups();
	}

	deleteTerritories(id: number) {
		if (window.confirm('Are you sure you want to delete this Territories?') == true)
		{
			this.TerritoriesService.deleteTerritories(this.objTerritories.TerritoryID.toString())
			.subscribe(record => this.router.navigate(['/Territories']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('Territories record deleted successfully...'); }
			);
		}
	}
	gotoTerritoriesEdit() {
		this.router.navigate(['/Territories', this.objTerritories.TerritoryID]);
	}

	gotoTerritories() {
		this.router.navigate(['/Territories']);
	}

	// Get Lookup List for Region
    getRegion() {
		this.RegionService.getAll().subscribe(records => this.RegionList=records);
    }

	getLookups() {

        this.getRegion();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Territories/TerritoriesDetails.component.ts